import axios from 'utils/axios';
import _ from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';

const urls = {
  allStores: 'store/allstores',
  category: 'category',
  subCategory: 'subCategory',
  brand: '/brand',
  store: '/store',
  uploadStoreImages: '/store/uploadStoreImages',
  updateStoreStatus: '/store/updateStatus',
  stateCityList: '/stateCityList',
  gstVerify: '/store/initiate-business-verify',
  storeApprove: '/store/approve-business-verify',
  getAdhaarOtpVerify: '/store/verify-aadhar-otp',
  getStoreByCity: '/store/getStoresByCity',
  getAllStoresPaginated: '/store/admin-store-paginated',
  getAllTotalStoresCount: '/store/countAllStores',
  getNearestStore: '/store/getNearestStore'
};

export const getStoreGstVerifyApi = createAsyncThunk('store/gstVerification', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.gstVerify}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getStoreApproveApi = createAsyncThunk('store/getStoreApproveApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.storeApprove}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAdhaarOtpVerifyApi = createAsyncThunk('store/getAdhaarOtpVerifyApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getAdhaarOtpVerify}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAllStoresApi = createAsyncThunk('serviceplug/getAllStores', async (params, thunkApi) => {
  try {
    const response = await axios.post(urls.allStores, params);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const deleteStoreApi = createAsyncThunk('serviceplug/deleteStoreApi', async (params, thunkApi) => {
  try {
    const response = await axios.delete(`${urls.store}/${params.storeId}`);
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getAllCategoryApi = createAsyncThunk('user/categoryApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.category}`,
      method: 'get',
      params
    });
    const data = await response.data;
    if (Array.isArray(data?.list)) {
      return data.list;
    }
    return [];
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAllSubCategoryApi = createAsyncThunk('user/subCategoryApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.subCategory}`,
      method: 'post',
      data: params
    });
    const data = await response.data;
    if (Array.isArray(data?.list)) {
      return data.list;
    }
    return [];
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getBrandListApi = createAsyncThunk('user/brandApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.brand}`,
      method: 'post',
      data: params
    });
    const data = await response.data;
    if (Array.isArray(data?.list)) {
      return data.list;
    }
    return [];
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const createStoreApi = createAsyncThunk('user/createStoreApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.store}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const uploadStoreImagesApi = createAsyncThunk('user/uploadStoreImagesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.uploadStoreImages}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updateStoreStatusApi = createAsyncThunk('user/updateStoreStatusApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateStoreStatus}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getStoreByStoreIdApi = createAsyncThunk('serviceplug/StoreByStoreId', async (params, thunkApi) => {
  try {
    const response = await axios.get(`${urls.store}`, { params });
    if (!_.isEmpty(response.data?.result)) {
      return response.data.result[0];
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const updateStoreApi = createAsyncThunk('user/updateStoreApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.store}`,
      method: 'put',
      data: params
    });
    const data = await response.data;
    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getStateCityListApi = createAsyncThunk('serviceplug/getStateCityListApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.stateCityList);
    if (response.data?.stateCityList) {
      return response.data.stateCityList;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getStoreByCityApi = createAsyncThunk('user/getStoreByCityApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getStoreByCity}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAllStoresPaginatedApi = createAsyncThunk(
  'serviceplug/getAllStoresPaginatedApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.post(urls.getAllStoresPaginated, params);
      if (response.data?.result) {
        return {
          result: response.data?.result,
          isAppend: params.isAppend,
          hasMoreStoreData: _.isArray(response.data?.result) && response.data?.result?.length > 9
        };
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getTotalStoresCountApi = createAsyncThunk(
  'serviceplug/getTotalStoresCountApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(urls.getAllTotalStoresCount, { params });
      if (!_.isEmpty(response.data?.result)) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getNearestStoreApi = createAsyncThunk('serviceplug/getNearestStore', async (params, thunkApi) => {
  try {
    const response = await axios.post(urls.getNearestStore, params);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});
